<div class="row justify-content-end">
    <div class="basic-container fullWidthBtn">
        <form class="outlined">
            <mat-form-field>
                <input #box type="text" matInput [ngClass]="!showInput?'inputOut':'inputIn'" class="form-control bg-light border-0 small"
                [formControl]="searchField"  
                (keyup.enter)="onEnter(box.value)">
               <!--[matAutocomplete]="auto"

                   <mat-autocomplete  #auto="matAutocomplete">
                    <mat-option *ngFor="let dispositivo of filtrado" [value]="dispositivo.nombre">
                        {{dispositivo.nombre}} <span class="device-factory">({{dispositivo.factoryName}}-{{dispositivo.groupName}})</span>
                    </mat-option>
                </mat-autocomplete> -->
            </mat-form-field>
        </form>
    </div>
</div>